<template>
  <div class="home">
    <!-- <van-nav-bar left-text="" title="" @click-right="onClickRight">
      <template #right>
        <van-icon name="search" size="20" />
      </template>
    </van-nav-bar> -->
    <div
      class="search-box flex flex-align-center flex-pack-center"
      @click="onSearch"
    >
      <van-icon name="search" size="20" />
      搜索
    </div>
    <article-list />
  </div>
</template>
<script>
  import ArticleList from '@/components/ArticleList'
  import { useRouter } from 'vue-router'
  import { wxShare } from '@/utils'
  import { onMounted } from 'vue'
  import store from '@/store'
  export default {
    components: {
      ArticleList,
    },
    setup() {
      const url = ''
      const router = useRouter()
      const onSearch = () => {
        router.push({ name: 'Search', query: { random: Math.random() } })
      }
      onMounted(() => {
        // eslint-disable-next-line no-undef
        init()
      })
      const init = async () => {
        const tenant = await store.getters['user/getTenant']
        const getCaseName = store.getters['user/getCaseName']
        wxShare(
          getCaseName,
          tenant.TenantProfile || tenant.TenantDesc || '案例云'
        )

        // 跳转新版
        let url = await store.getters['system/getH5Url']
        url += 'home/#/pages/index/index'
        location.href = url
      }
      return {
        url,
        onSearch,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .search-box {
    margin: 8px;
    background: #fff;
    padding: 6px;
    color: #999;
    border-radius: 3px;
  }
</style>
